export default __webpack_public_path__ + "static/media/think_dev_mobile.8fef2a54.png";